import * as angular from 'angular';
import * as c3 from 'c3';
import * as d3 from 'd3';

(function () {
    'use strict';

    angular.module('app').directive('networkPointGraph', networkPointGraph);

    /**
     * This is a directive for the Network Point graph.
     *
     * @author bjnowak.btc
     * @ngInject
     */
    function networkPointGraph() {
        return {
            restrict: 'A',
            link: function postLink(scope, element, attr) {
                var chartData = angular.fromJson(attr.graphData);

                setTimeout(function () {
                    c3.generate({
                        padding: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        bindto: element[0],
                        data: {
                            json: chartData.scene,
                            xFormat: '%Y-%m-%dT%H:%M:%S.%LZ',
                            keys: {
                                x: 'date',
                                value: ['marketable', 'requested']
                            },
                            types: {
                                requested: 'area',
                                marketable: 'area'
                            },
                            colors: {
                                marketable: 'gray',
                                requested: '#4ab796'
                            }
                        },
                        legend: {
                            show: false
                        },
                        point: {
                            show: false
                        },
                        axis: {
                            x: {
                                type: 'timeseries',
                                tick: {
                                    format: '%d-%m-%y'
                                },
                                show: false,
                                padding: {
                                    left: 0,
                                    right: 0
                                }
                            },
                            y: {
                                min: 0,
                                padding: {
                                    bottom: 0,
                                    top: 0
                                },
                                tick: {
                                    format: function (d) {
                                        return (
                                            d3.format(',f')(d) +
                                            ' ' +
                                            chartData.variables.unit
                                        );
                                    }
                                },
                                show: false
                            }
                        },
                        regions: [
                            {
                                axis: 'x',
                                start: 29,
                                end: 34,
                                class: 'regionX'
                            }
                        ],
                        tooltip: {
                            contents: function (
                                d,
                                defaultTitleFormat,
                                defaultValueFormat,
                                color
                            ) {
                                var $$ = this,
                                    config = $$.config,
                                    CLASS = $$.CLASS,
                                    titleFormat =
                                        config.tooltip_format_title ||
                                        defaultTitleFormat,
                                    nameFormat =
                                        config.tooltip_format_name ||
                                        function (name) {
                                            return name;
                                        },
                                    valueFormat =
                                        config.tooltip_format_value ||
                                        defaultValueFormat,
                                    text,
                                    i,
                                    title,
                                    value,
                                    name,
                                    bgcolor;
                                var format = d3.time.format(
                                    '%Y-%m-%dT%H:%M:%S.%LZ'
                                );
                                var count = 0;
                                for (i = 0; i < d.length; i++) {
                                    if (d[i].id == 'requested') {
                                        if (
                                            !(
                                                d[i] &&
                                                (d[i].value || d[i].value === 0)
                                            )
                                        ) {
                                            continue;
                                        }
                                        if (!text) {
                                            var date = format.parse(
                                                chartData.scene[d[i].index].date
                                            );
                                            title =
                                                date.getDate() +
                                                '/' +
                                                (date.getMonth() + 1) +
                                                '/' +
                                                date.getFullYear();
                                            text =
                                                "<table class='" +
                                                CLASS.tooltip +
                                                "'>" +
                                                (title || title === 0
                                                    ? "<tr><th colspan='2'>" +
                                                      title +
                                                      '</th></tr>'
                                                    : '');
                                        }
                                    }
                                }
                                text +=
                                    "<tr class='" + CLASS.tooltipName + "'>";
                                text +=
                                    "<td class='name'>" +
                                    'Surcharge: ' +
                                    chartData.surcharges[d[0].index].surcharge
                                        .value +
                                    ' ' +
                                    chartData.variables.unit +
                                    '/Runtime</td>';
                                text += '</tr></table>';
                                $('g')
                                    .filter(function () {
                                        return (
                                            $(this).css('visibility') ==
                                                'hidden' ||
                                            $(this).css('display') == 'none'
                                        );
                                    })
                                    .remove();
                                return text;
                            }
                        }
                    });
                }, 0);
            }
        };
    }
})();
